module.exports = __webpack_public_path__ + "img/TuxRainbow.1557441c.png";